import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChatPanelCollapse = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 10,
	height: 10,
	viewBox: "0 -1 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M0.183056 0.183056C0.427131 -0.0610188 0.822865 -0.0610188 1.06694 0.183056L4.40025 3.51641C4.64433 3.7605 4.64433 4.15617 4.40025 4.40025L1.06694 7.73358C0.822865 7.97767 0.427131 7.97767 0.183056 7.73358C-0.0610188 7.4895 -0.0610188 7.09383 0.183056 6.84975L3.07445 3.95833L0.183056 1.06694C-0.0610188 0.822865 -0.0610188 0.427131 0.183056 0.183056ZM5.18308 0.183056C5.42716 -0.0610188 5.82283 -0.0610188 6.06691 0.183056L9.40025 3.51641C9.64433 3.7605 9.64433 4.15617 9.40025 4.40025L6.06691 7.73358C5.82283 7.97767 5.42716 7.97767 5.18308 7.73358C4.939 7.4895 4.939 7.09383 5.18308 6.84975L8.07441 3.95833L5.18308 1.06694C4.939 0.822865 4.939 0.427131 5.18308 0.183056Z",
		fill: "currentColor"
	})
});
export default SvgChatPanelCollapse;
